import { useState, useLayoutEffect } from 'react';

/**
 * Для использовать "загрузки" компонента, если он долго отрисовывается,
 * например, для громоздких таблиц
 */
export const useFakeLoading = () => {
  const [fakeLoading, setFakeLoading] = useState(true);
  useLayoutEffect(() => {
    setTimeout(() => {
      setFakeLoading(false);
    }, 1);
  }, []);
  return fakeLoading;
};
